import PageWrap from "@/components/PageWrap";
// import GaStepOne from "./gaStepOne";
// import GaStepTwo from "./gaStepTwo";
// import GaStepThree from "./gaStepThree";
import { useState, useEffect } from "react";
// import { Box } from "@chakra-ui/react";
// import ResetPwd from "./resetPwd";
import { useAppSelector } from "@/state/hooks";
import { useDispatch } from "react-redux";
import LoginAndRegisterBindGa from "@/pages/login/BindGa.js";
import Email from "@/pages/fogetPwd/email.js";
import Phone from "@/pages/fogetPwd/phone";
import Ga from "@/pages/fogetPwd/ga";
import { postValidationItemFunc } from "@/pages/resetAccountInfo/api";

const BindGA = () => {
  const userInfo = useAppSelector((state) => state.user.userInfo);

  const [step, setStep] = useState(0);
  const dispatch = useDispatch();
  const [request_id, setRequest_id] = useState("");
  const postValidationItem = async () => {
    const securityElem = "GOOGLE_AUTH";

    const res = await postValidationItemFunc({
      security_elem: securityElem,
      email: userInfo?.email,
      phone: userInfo?.phone_number,
      scene: "UPDATE",
    });
    if (res.code === 0) {
      // setStep(4);
      setRequest_id(res.data.request_id);
      if (res.data.security_elems[0] === "PHONE") {
        setStep(2);
      }
      if (res.data.security_elems[0] === "EMAIL") {
        setStep(1);
      }
      if (res.data.security_elems[0] === "GOOGLE_AUTH") {
        setStep(3);
        console.log("跳转到谷歌验证码");
      }
    }
  };
  const getStep = (value) => {
    setStep(value);
  };
  useEffect(() => {
    postValidationItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageWrap>
      {step === 1 && <Email request_id={request_id} getStep={getStep} />}
      {step === 2 && <Phone request_id={request_id} getStep={getStep} />}
      {step === 3 && <Ga request_id={request_id} getStep={getStep} />}
      {step === 4 && (
        <LoginAndRegisterBindGa
          emailInfo={userInfo?.email}
          password={null}
          needVerifyPaymentPassword={false}
          isModifyGa={true}
        />
      )}

      {/* <Box
        style={{ backgroundColor: "#fff" }}
        height={"auto"}
        minHeight={"100vh"}
        overflow={"hidden"}
      >
        {step === 1 && <GaStepOne getStep={getStep} />}
        {step === 2 && <GaStepTwo getStep={getStep} />}
        {step === 3 && <GaStepThree getStep={getStep} />}
      </Box> */}
    </PageWrap>
  );
};

export default BindGA;
